import { UserMode } from '../enums';

export class CarbonCopyInput {
    public userId?: number | null = null;
    public userMode?: UserMode = UserMode.CustomerEmployee;
    public email: string = '';
    public isBlindCarbonCopy: boolean = false;
}
